/**
 * A single search filter. Used by {@link TmrSearchFormFilters}
 *
 * @type {ngFactory}
 */
function TmrSearchFormFilterFactory($translate) {
  'ngInject'

  class TmrSearchFormFilter {
    constructor(_param, _label, value, _formatter = value => ({ value })) {
      Object.assign(this, { _param, _label, value, _formatter, updated: false })
    }

    get label() {
      return $translate.instant(this._label)
    }

    get param() {
      return this._param
    }

    /**
     * Returns the formatted value.
     * Formatter callbacks are defined in {@link tmrResourceFilterController}
     */
    get formatted() {
      if (this.value === undefined)
        throw new Error(
          `Trying to render SearchFormFilter ${this._param} with no value`
        )
      return (Array.isArray(this.value) ? this.value : [this.value]).map(
        this._formatter
      )
    }
  }

  return TmrSearchFormFilter
}

export const factory = ['TmrSearchFormFilter', TmrSearchFormFilterFactory]
